// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vs-select[data-v-7ad661b4] {\n  min-width: 200px;\n}\r\n", ""]);
// Exports
module.exports = exports;
